const hasValue = value => value !== undefined && value !== null && value !== ''

const firstValue = (...values) => values.find(hasValue)

export const buildDepartmentOptions = departments => (departments || [])
    .map(department => {
        const value = firstValue(
            department.DING_DEPT_ID,
            department.dingDeptId,
            department.dingdingDeptId,
            department.id,
        )
        const label = firstValue(
            department.DEPT_NAME,
            department.deptName,
            department.name,
            value,
        )
        return { value, label: hasValue(label) ? String(label) : '' }
    })
    .filter(option => hasValue(option.value) && hasValue(option.label))

export const buildUserOptions = users => (users || [])
    .map(user => {
        const value = firstValue(user.USER_ID, user.userId, user.id)
        const label = firstValue(
            user.USER_NICK,
            user.userNick,
            user.nickName,
            user.USER_NAME,
            user.userName,
            value,
        )
        return { value, label: hasValue(label) ? String(label) : '' }
    })
    .filter(option => hasValue(option.value) && hasValue(option.label))
